let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8lCJf")).then(() => parcelRequire('5J9Qe'));